// Service helper for Keap Partner 1:1 Link scheduling
export const kP11LinkService = {
  async fetchAvailableTimeSlot(client, url) {
    try {
      const response = await client(url)
      return response
    } catch (error) {
      console.error('Error fetching available time slots:', error)
      throw error
    }
  },

  async confirmScheduleSlot(client, endpoint, data) {
    try {
      const response = await client(endpoint, {data, method: 'POST'})
      return response
    } catch (error) {
      console.error('Error confirming schedule slot:', error)
      throw error
    }
  },

  async captureAppoinmentDetail(client, url, data) {
    try {
      const response = await client(url, {data, method: 'POST'})
      return response
    } catch (error) {
      console.error('Error capturing appointment detail:', error)
      throw error
    }
  },
}
